import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController, ToastController } from '@ionic/angular';
import { Subject, takeUntil } from 'rxjs';
import { User } from 'src/app/models/user';
import { Viewer, ViewerPhoto } from 'src/app/models/viewer';
import { Visit, VisitLike, VisitUser } from 'src/app/models/visit';
import { AuthService } from 'src/app/services/auth.service';
import { MiradoresService } from 'src/app/services/miradores.service';
import { PushNotificationService } from 'src/app/services/push-notification.service';
import { VisitLikesManagerService } from 'src/app/services/visitLike-manager.service';
// import Swiper core and required modules
import SwiperCore, { Pagination, SwiperOptions, Zoom } from "swiper";
import { SwiperComponent } from 'swiper/angular';

SwiperCore.use([Zoom, Pagination]);

@Component({
  selector: 'app-modal-viewer-activity',
  templateUrl: './modal-viewer-activity.component.html',
  styleUrls: ['./modal-viewer-activity.component.scss'],
})
export class ModalViewerActivityComponent implements OnInit, OnDestroy {
  @ViewChild('swiper') swiper: SwiperComponent;
  @Input() data: Viewer ;
  config: SwiperOptions;

  currentSesion: User;
  currentUserVisitLikes: VisitLike[] = [];
  avoidSessionInteractionButtonsClicks: boolean = false;
  private unsubscribe$ = new Subject<void>();

  constructor(private modalCtrl: ModalController, 
    public MIService: MiradoresService, 
    private router: Router, 
    public auth: AuthService,
    private toastController: ToastController,
    private visitLikeService: VisitLikesManagerService,
    private pushNotificationService: PushNotificationService) {

   }

   getSession() {
    this.auth.$establishedSession
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(user => {
      this.currentSesion = user;

      this.auth.$myVisitLikes
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((visits)=> {
        if(visits.length) {
          this.currentUserVisitLikes = visits;
        }
      });
    })
  }

  zoom(zoomIn: boolean) {
    const zoom = this.swiper.swiperRef.zoom;
    zoomIn ? zoom.in() : zoom.out();
  }

  ngOnInit() {
    this.config = {
      initialSlide: this.data.initialSlide,
      zoom: { maxRatio: 3, minRatio: 0.2 },
      navigation: true,
    };

    this.getSession();
  }

  close () {
    this.modalCtrl.dismiss();
  }

  linkMirador(nameMirador: string) {
    this.router.navigate(['/mirador', this.MIService.getNormalizedMiradorNameForURL(nameMirador)]);
    this.close()
  }

  async checkLikeVisit(photo: ViewerPhoto) {
    if (this.currentSesion) {
      if (!this.avoidSessionInteractionButtonsClicks) {
        this.avoidSessionInteractionButtonsClicks = true;
        let foundLike = this.visitAlreadyLike(photo);
        if (foundLike) {
          this.unlikeVisit(photo, foundLike.likeId);
        } else {
          this.likeVisit(photo)
        }
      }
    } else {

      const toast = await this.toastController.create({
        message: 'Debes haber iniciado sesión para realizar esta acción',
        duration: 3000,
        position: 'bottom',
        buttons: [
          {
            text: 'Iniciar Sesión',
            role: 'info',
            handler: () => { this.router.navigate(['/login']) }
          }
        ]
      });

      await toast.present();
    }
  }

  visitAlreadyLike(photo: ViewerPhoto) {
    let foundLike = this.currentUserVisitLikes.find((visitLike) => {
      return visitLike.visitId == photo.visitId;
    });

    // if(foundLike) {
    //   this.alreadyLiked = true;
    //   this.foundLikeId = foundLike.likeId;
    // }
    return foundLike;
  }

  likeVisit(photo: ViewerPhoto) {
    this.visitLikeService.SetLikedData(this.currentSesion, photo.visitId);
    let susc = this.visitLikeService.$isVisitLikeProcessDone
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((likeId) => {
      if(likeId) {
        // this.alreadyLiked = true;
        // this.foundLikeId = likeId;
        photo.countLikes++; 
        this.avoidSessionInteractionButtonsClicks = false;
        this.pushNotificationService.sendLikeVisitPushNotification(this.currentSesion, photo.userId);
        susc.unsubscribe();
      }
    })
  }

  unlikeVisit(photo: ViewerPhoto, likeId: string) {
    this.visitLikeService.removeLike(likeId, photo.visitId);
    let susc = this.visitLikeService.$isVisitLikeProcessDone
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((isDone) => {
      if(isDone) {
        // this.alreadyLiked = false;
        // this.foundLikeId = null;
        photo.countLikes--;
        this.avoidSessionInteractionButtonsClicks = false;
        susc.unsubscribe();
      }
    })
  }

  ngOnDestroy(): void {
    // Liberar recursos manualmente si es necesario
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
